import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import { ClipboardText, GavelIcon, Timer } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import {
  BankTransferIcon,
  Chip,
  EnabledTransactionTypesPill,
  GiftCardIcon,
  OriginalPaymentMethodIcon,
  Text,
} from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'

import * as Styles from './styles'

const ExceptionInfo = ({ exception, policyRules }) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()
  const { info } = useContext(AppContext)
  const hasRestrictedRefundMethods = exception?.only_store_credit || exception?.only_gift_card
  const restrictedIconType = hasRestrictedRefundMethods ? 'slashed' : 'default'
  const linkedPolicyRule = policyRules?.find(rule => rule.id === exception?.policy_rule_id)

  return (
    <Styles.MainContainer>
      <Text type="titleS">{t('Excepciones')}</Text>
      <Styles.InfoContainer>
        <Styles.HeaderAndChipsContainer>
          <Styles.Header>
            <Styles.HeaderName type="bodyMBold">
              <ClipboardText size={20} />
              {exception.order_number}
            </Styles.HeaderName>
            <Styles.HeaderDate type="bodyMRegular">
              <Timer size={20} />
              {t('Expira')}:{' '}
              {new Intl.DateTimeFormat(i18n.language, { timeZone: info?.selectedStore?.timezone }).format(
                new Date(exception?.expires_at)
              )}
            </Styles.HeaderDate>
          </Styles.Header>
        </Styles.HeaderAndChipsContainer>
        <Styles.ChipsContainer>
          <EnabledTransactionTypesPill
            refund={exception.enabled_for_refunds}
            exchange={exception.enabled_for_exchanges}
            isDisabled={exception.disabled}
          />
          {linkedPolicyRule && (
            <Tooltip title={linkedPolicyRule.name}>
              <Chip
                disabled={exception.disabled}
                backgroundColor={theme.colors.disabled.surface}
                Icon={GavelIcon}
                label={linkedPolicyRule.internal_id}
              />
            </Tooltip>
          )}
        </Styles.ChipsContainer>
        <Styles.MethodsAndChipsContainer>
          <Tooltip
            title={
              hasRestrictedRefundMethods
                ? t('Solo habilitado Crédito en tienda')
                : t('Habilitados todos los métodos de reembolso')
            }
          >
            <Styles.MethodsContainer>
              <Styles.MethodContainer isDisabled={exception.disabled || hasRestrictedRefundMethods}>
                <BankTransferIcon size={16} type={restrictedIconType} />
              </Styles.MethodContainer>
              <Styles.MethodContainer isDisabled={exception.disabled || hasRestrictedRefundMethods}>
                <OriginalPaymentMethodIcon size={16} type={restrictedIconType} />
              </Styles.MethodContainer>
              <Styles.MethodContainer isDisabled={exception.disabled}>
                <GiftCardIcon size={16} />
              </Styles.MethodContainer>
            </Styles.MethodsContainer>
          </Tooltip>
          {exception.disable_return_fees && (
            <Chip
              disabled={exception.disabled}
              backgroundColor={theme.colors.disabled.surface}
              color={theme.colors.accent.hover}
              label={<Text type="bodySBold">{t('Transacción gratuita')}</Text>}
            ></Chip>
          )}
        </Styles.MethodsAndChipsContainer>

        {exception?.notes && (
          <Text type="bodyMRegular" color={theme.colors.text.muted}>
            {exception?.notes}
          </Text>
        )}
      </Styles.InfoContainer>
    </Styles.MainContainer>
  )
}

export default ExceptionInfo
